<template>
  <NfFormItem icon="school" :label="label" @click="handleClick">
    <div v-if="showInput" class="input-wrapper" slot="right">
      <input class="input-school text input" placeholder="请输入学校" v-model="customSchoolName" />
    </div>
    <div v-else class="select-wrapper" slot="right">
      <span class="text" :class="labelValue === placeholder ? 'placeholder' : ''">{{ labelValue }}</span>
      <i class="icon icon-arrow-right"></i>
    </div>
  </NfFormItem>
</template>

<script>
import NfFormItem from "./NfFormItem"
import { mapMutations } from "vuex"

export default {
  name: "uiFormItemSchool",
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    label: {
      type: String,
      default: "学校"
    },
    showInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customSchoolName: ""
    }
  },
  methods: {
    ...mapMutations({
      setSelectSchoolInfo: "userInfo/setSelectSchoolInfo"
    }),
    handleClick() {
      if (this.showInput) return
      this.$router.push({ path: "/chooseSchool" })
    },
    initCustonSchoolName() {
      this.customSchoolName = this.value.schoolName
    }
  },
  components: {
    NfFormItem
  },
  computed: {
    labelValue: {
      get() {
        return this.value.schoolName || this.placeholder
      },
      set(value) {
        this.$emit("input", value)
      }
    }
  },
  watch: {
    customSchoolName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setSelectSchoolInfo({
          schoolId: "",
          schoolName: newVal
        })
      }
    },
    showInput() {
      this.customSchoolName = ""
      this.setSelectSchoolInfo({
        schoolId: "",
        schoolName: ""
      })
    }
  },
  mounted() {
    this.initCustonSchoolName()
  },
  activated() {
    if (this.showInput) {
      this.initCustonSchoolName()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrapper {
  display: flex;
  align-items: center;
  overflow: hidden;
  .input-school {
    border: none;
    background: transparent;
    outline: none;
  }
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 0.2rem;
    &.placeholder {
      color: #999999;
    }
  }
  .icon-arrow-right {
    width: 0.3rem;
    height: 0.3rem;
    background: url("../../assets/images/icon_arrow.png") no-repeat center;
    background-size: 100%;
    flex: none;
  }
}
.input-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    color: #333333;
    text-align: right;
    &::-webkit-input-placeholder {
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      color: #cccccc;
    }
  }
}
</style>
